import { Html, useProgress } from '@react-three/drei';
import { useCallback } from 'react';
import styled from 'styled-components';
import * as THREE from 'three';

const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #171717;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 300ms ease;
  z-index: 1000;
  margin: 16px;
`;

const Inner = styled.div`
  width: 100px;
  height: 3px;
  background: #272727;
  text-align: center;
`;

const Bar = styled.div`
  height: 3px;
  width: 100%;
  background: white;
  transition: transform 200ms;
  transform-origin: left center;
  border-radius: 2px;
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.2);
`;

const ProgressText = styled.span`
  display: inline-block;
  position: relative;
  font-variant-numeric: tabular-nums;
  margin-top: 0.8em;
  color: #1d1d1d;
  font-size: 0.6em;
  font-family:
    -apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', 'Helvetica Neue', Helvetica, Arial,
    Roboto, Ubuntu, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
  white-space: nowrap;
`;

export const Loader: React.FC<{ message: string; top?: React.CSSProperties['top'] }> = ({
  message,
  top,
}) => {
  const { active, progress } = useProgress();

  const calculatePosition = useCallback(
    (_: THREE.Object3D, __: THREE.Camera, size: { width: number; height: number }) => {
      return [size.width * 0.5, 0, 0];
    },
    [],
  );

  return (
    <Html
      calculatePosition={calculatePosition}
      visible={active}
      style={{ pointerEvents: 'none', zIndex: 1000 }}
    >
      <Container style={{ opacity: active ? 1 : 0, top: top ?? '50%' }}>
        {active && (
          <Inner>
            <Bar style={{ transform: `scaleX(${progress / 100})` }} />
          </Inner>
        )}
        <ProgressText>
          {message} {Math.round(progress)}%
        </ProgressText>
      </Container>
    </Html>
  );
};
